export const UPDATE_INVITE_DRIVER_DETAILS = "UPDATE_INVITE_DRIVER_DETAILS";
export const UPDATE_PASSWORD_DETAILS = "UPDATE_PASSWORD_DETAILS";
